var script_loaded = false;
function loadAsync() {
    if (script_loaded) return;
    script_loaded = true;
    var scripts = document.getElementsByTagName("script");
    for (var i = 0; i < scripts.length; i++) {
        var script = scripts[i];
        if (script.getAttribute("data-src") !== null) {
            script.setAttribute("src", script.getAttribute("data-src"));
            delete script.dataset.src;
        }
        if (script.getAttribute("type") == "text/javascripts") {
            var newScript = document.createElement("script");
            for (var j = 0; j < script.attributes.length; j++) {
                var attr = script.attributes[j];
                newScript.setAttribute(attr.name, attr.value);
            }
            newScript.type = "text/javascript";
            newScript.innerHTML = script.innerHTML;
            script.parentNode.removeChild(script);
            script.parentNode.insertBefore(newScript, script);
        }
    }
    setTimeout(function() {
        document.dispatchEvent(new CustomEvent("StartAsyncLoading"));
    }, 900);
    document.dispatchEvent(new CustomEvent("startasyncloading"));
}
window.addEventListener("scroll", function() {
    loadAsync();
});
window.addEventListener("mousemove", function() {
    loadAsync();
});
window.addEventListener("touchstart", function() {
    loadAsync();
});
if (window.addEventListener) {
    window.addEventListener("load", function() {
        setTimeout(loadAsync, 9000);
    }, false);
} else {
    if (window.attachEvent) {
        window.attachEvent("onload", function() {
            setTimeout(loadAsync, 9000);
        });
    } else {
        window.onload = loadAsync;
    }
}